import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

/**
 * Selects websocket slice of the state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {WebsocketState list of websocket
 */
export const selectWebsocket = createKeySelector('websocket');

/**
 * Gets whether the websocket is connected
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {boolean} whether or not the websocket is connected
 */
export const getIsConnected = createSelector(selectWebsocket, (websocket) => websocket.isConnected);

/**
 * Gets the date of the last nudge from the websocket
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {number} timestamp of the last nudge
 */
export const getLastNudgeDate = createSelector(
  selectWebsocket,
  (websocket) => websocket.lastNudgeDate
);
